import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import {
    IContentDetailsResponse,
} from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetContentDetailsUseCase {
    execute(guid: string): Promise<IContentDetailsResponse>;
}

export class GetContentDetailsUseCase implements IGetContentDetailsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(guid: string): Promise<IContentDetailsResponse> {
        return this.mpxRepository.getContentDetailByGuid(guid);
    }
}
